export var checkboxTheme = {
  baseStyle: {
    container: {
      cursor: 'pointer',
      display: 'inline-flex',
      _disabled: {
        cursor: 'not-allowed'
      },
      _readOnly: {
        cursor: 'default'
      }
    },
    checkboxContainer: {
      position: 'relative',
      display: 'inline-flex'
    },
    checkbox: {
      appearance: 'none',
      cursor: 'pointer',
      height: '20px',
      width: '20px',
      paddingY: 'xxxs',
      borderRadius: 'm',
      border: 'basic.dark',
      backgroundColor: 'transparent',
      _hover: {
        border: 'basic.darker'
      },
      _checked: {
        backgroundColor: 'brand.main',
        border: 'input.brand',
        _disabled: {
          border: 'input.disabled',
          backgroundColor: 'neutral.light',
          cursor: 'not-allowed'
        },
        _readOnly: {
          border: 'basic.darker',
          backgroundColor: 'neutral.darker'
        },
        _invalid: {
          border: 'input.error',
          backgroundColor: 'critical.main'
        }
      },
      _indeterminate: {
        backgroundColor: 'brand.main',
        border: 'input.brand',
        _disabled: {
          border: 'input.disabled',
          backgroundColor: 'neutral.light',
          cursor: 'not-allowed'
        },
        _invalid: {
          border: 'input.error',
          backgroundColor: 'critical.main'
        }
      },
      _invalid: {
        border: 'input.error'
      },
      _readOnly: {
        border: 'basic.dark',
        cursor: 'default'
      },
      _disabled: {
        border: 'input.disabled',
        cursor: 'not-allowed'
      },
      _focusVisible: {
        outlineStyle: 'solid',
        outlineWidth: '2px',
        outlineColor: 'focus.focus',
        transition: 'outline-color 0.1s'
      }
    },
    innerIcon: {
      position: 'absolute',
      top: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    label: {
      color: 'neutral.black',
      _disabled: {
        color: 'neutral.light',
        opacity: 1 //  override chakra's 0.4 opacity

      },
      _readOnly: {
        color: 'neutral.darker'
      }
    }
  },
  sizes: {
    small: {
      checkboxContainer: {
        // Increase hit area to 24px to comply to a11y
        // Based on https://stackoverflow.com/a/20327676/23707657
        padding: 'xxs',
        margin: '-4px',
        marginTop: {
          s: '-2px'
        },
        '&[data-with-label="false"]': {
          marginTop: {
            s: '-4px'
          }
        }
      },
      checkbox: {
        height: '16px',
        width: '16px'
      },
      label: {
        textStyle: 'body3'
      },
      innerIcon: {
        width: '24px',
        height: '24px'
      }
    },
    large: {
      checkboxContainer: {
        // Increase hit area to 24px to comply to a11y
        // Based on https://stackoverflow.com/a/20327676/23707657
        padding: 'xxxs',
        margin: '-2px',
        marginTop: 'none',
        '&[data-with-label="false"]': {
          marginTop: '-2px'
        }
      },
      checkbox: {
        height: '20px',
        width: '20px'
      },
      label: {
        textStyle: 'body2'
      },
      innerIcon: {
        width: '24px',
        height: '24px'
      }
    }
  }
};
//# sourceMappingURL=Checkbox.theme.js.map